import { useState, useEffect } from 'react';

export const useAnchorParams = () => {
  const [el, setEl] = useState<HTMLElement | null>(null);

  const getOffset = () => {
    if (el && el.parentElement) {
      const zoom =
        // @ts-ignore
        parseFloat(el.style.zoom) ||
        parseFloat(el.style.scale) ||
        // @ts-ignore
        parseFloat(el.parentElement.style.zoom) ||
        parseFloat(el.parentElement.style.scale) ||
        1;
      return el.getBoundingClientRect().left * zoom;
    }

    return 0;
  };
  const getFontSize = () => {
    if (el && el.parentElement) {
      const zoom =
        // @ts-ignore
        parseFloat(el.style.zoom) ||
        parseFloat(el.style.scale) ||
        // @ts-ignore
        parseFloat(el.parentElement.style.zoom) ||
        parseFloat(el.parentElement.style.scale) ||
        1;
      const fs = getComputedStyle(el).fontSize;
      return `${parseInt(fs) * zoom}px`;
    }

    return null;
  };

  const [offset, setOffset] = useState(getOffset());
  const [fontSize, setFontSize] = useState(getFontSize());

  useEffect(() => {
    let interval: NodeJS.Timer | null = null;

    if (process.env.REACT_APP_LEFT_OFFESET_SELECTOR) {
      interval = setInterval(() => {
        const queryEl = document.querySelector(
          process.env.REACT_APP_LEFT_OFFESET_SELECTOR || ''
        ) as HTMLElement | null;

        if (queryEl) {
          setEl(queryEl);

          if (interval) {
            clearInterval(interval);
          }
        }
      }, 100);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  useEffect(() => {
    if (!el) {
      return;
    }

    setOffset(getOffset());
    setFontSize(getFontSize());

    let observer = new MutationObserver(() => {
      setOffset(getOffset());
      setFontSize(getFontSize());
    });
    const config = {
      attributes: true,
    };

    if (el) {
      observer.observe(el, config);
    }

    return () => {
      observer.disconnect();
    };
  }, [el]);

  return { offset, fontSize };
};
